import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ComponentForm from "../../components/ComponentForm";
import * as Styled from "./styled";
import { ServicesContext } from "../../context/ContextServices/context";
import { createServices, updateServices } from "../../context/ContextServices/actions";
import { fields } from "./fields";

const NewService = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const serviceData = location.state?.service;

  const [isActiveButton, setIsActiveButton] = useState(
    serviceData?.status === "Concluído"
  );

const formatMoney = (value: number | string) => {
  let number: number;

  if (typeof value === "number") {
    number = value;
  } else {
    number = Number(
      value
        .replace(/\./g, "")
        .replace(",", ".")
    );
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number || 0);
};

  const [formData, setFormData] = useState(serviceData || {});

  const { dispatch } = useContext(ServicesContext);

  const handleFormChange = (data: any) => {
    setFormData(data);

    if (data.status === "Concluído") {
      setIsActiveButton(true);
    } else {
      setIsActiveButton(false);
    }
  };

  const parseMoney = (value: string | number) => {
  if (!value) return 0;

  return Number(
    String(value)
      .replace(/[^\d,.-]/g, "")
      .replace(/\./g, "")
      .replace(",", ".")
  );
};
const totalPecas =
  formData.extras?.pecaLoja_extra?.reduce(
    (total: number, item: any) => {
      const valor = parseMoney(item.valorVenda);

      return total + valor;
    },
    0
  ) || 0;
  const handleSubmit = (data: any) => {
    if (serviceData) {
      updateServices(dispatch, {
        ...data,
        id: serviceData.id
      });
    } else {
      createServices(dispatch, data);
    }

    navigate("/dashboard/services");
  };

  const handleSendWhatsApp = () => {
    if (!formData?.telefone) return;

    const telefone = formData.telefone.replace(/\D/g, "");

    const mensagem = `Olá ${formData.nomeCliente}!

MDMOTOS e serviços informa que o serviço da sua moto foi concluído.

Sua moto já está pronta para retirada.

valor total do serviço: ${formatMoney(formData.valorConserto)}
${formData.desconto ? `\nValor com desconto: R$ ${formatMoney(formData.valorConserto - Number(String(formData.desconto).replace(/\./g, "").replace(",", ".")))}` : ""}
${formData.desconto ? `\nDesconto: R$ ${formatMoney(formData.desconto)}` : ""}
${formData.extras?.pecaLoja_extra && formData.extras.pecaLoja_extra.length > 0 ? "\nPeças utilizadas:" : ""}
${formData.extras?.pecaLoja_extra
  ? formData.extras.pecaLoja_extra
      .map(
        ({
          produto,
          valorVenda,
        }: {
          produto: string;
          valorVenda: number;
        }) => `• ${produto} - ${formatMoney(valorVenda)}`
      )
      .join("\n")
  : ""}
${formData.extras?.pecaLoja_extra && formData.extras.pecaLoja_extra.length > 0 
? `\nTotal das peças: ${formatMoney(totalPecas)}`
: ""}
${formData.observacoes ? `\nObservações: ${formData.observacoes}` : ""}

Chave PIX para pagamento CNPJ: 14119529000133

Agradecemos pela preferência!
`;

    const url = `https://wa.me/55${telefone}?text=${encodeURIComponent(mensagem)}`;

    window.open(url, "_blank");
  };

  return (
    <Styled.Container>
      <ComponentForm
        title={serviceData ? "Editar Serviço" : "Novo Serviço"}
        fields={fields}
        initialData={serviceData}
        onSubmit={handleSubmit}
        onChange={handleFormChange} // 🔥 ESSENCIAL
        onCancel={() => navigate("/dashboard/services")}
      />

      <button
        disabled={!isActiveButton}
        onClick={handleSendWhatsApp}
        style={{
          margin: "16px 48px",
          backgroundColor: isActiveButton ? "#25D366" : "#A5D6A7",
          color: "#fff",
          padding: "10px 20px",
          border: "none",
          borderRadius: "5px",
          cursor: isActiveButton ? "pointer" : "not-allowed"
        }}
      >
        Mandar mensagem no WhatsApp
      </button>
    </Styled.Container>
  );
};

export default NewService;